import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable chat to multiple locales
 */
export const HELP_CENTER_ENABLE_LOCALES =
  'HELP_CENTER_ENABLE_LOCALES' as SettingConst<
    'HELP_CENTER_ENABLE_LOCALES',
    boolean,
    'HELP_CENTER'
  >;
